import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"download\">\n<defs>\n    <style>\n      #download .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M1638,66a1,1,0,0,1,1,1V77a1,1,0,1,1-2,0V67A1,1,0,0,1,1638,66Zm-9,14h18a1,1,0,1,1,0,2h-18A1,1,0,1,1,1629,80Zm13.94-7.928a1,1,0,0,1,0,1.414l-4.24,4.243a1,1,0,0,1-1.42-1.414l4.25-4.243A1,1,0,0,1,1642.94,72.072Zm-9.64.207a0.951,0.951,0,0,0,0,1.358l4.07,4.073a0.961,0.961,0,0,0,1.36-1.358l-4.08-4.073A0.951,0.951,0,0,0,1633.3,72.279Z\" transform=\"translate(-1628 -66)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/download.svg
// module id = UXgm
// module chunks = 268